import moment from "moment"

interface BaseProps {
  dateString: string
  ignoreLocal?: boolean
}

export function FormatDate({ dateString, ignoreLocal }: BaseProps) {
  const date = ignoreLocal ? moment.utc(dateString) : moment.utc(dateString).local()
  return date.format("dddd")
}

export function FormatTime({ dateString, ignoreLocal }: BaseProps) {
  const date = ignoreLocal ? moment.utc(dateString) : moment.utc(dateString).local()
  return <div>{date.format("D-MMMM")}</div>
}

export function FormatSlot({ dateString, ignoreLocal }: BaseProps) {
  const date = ignoreLocal ? moment.utc(dateString) : moment.utc(dateString).local()
  const formattedDate = date.format("Do MMMM YYYY")
  return <div>{formattedDate}</div>
}

export function FormatChangeTime({ dateString, ignoreLocal }: BaseProps) {
  const date = ignoreLocal ? moment.utc(dateString) : moment.utc(dateString).local()
  return <div>{date.format("h:mm A")}</div>
}

export function FormatYear({ dateString, ignoreLocal }: BaseProps) {
  const date = ignoreLocal ? moment.utc(dateString) : moment.utc(dateString).local()
  return <div>{date.format("YYYY")}</div>
}

